import React from 'react';
import { createBillingAddress, updateBillingAddress } from '../../app-main/actions/fee-profile';
import { SubmissionError } from 'redux-form';
import { omit } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitBillingAddressForm = (values = {}, dispatch, props) => {
  const { _id: feeProfileId, ssoId } = values;
  const { accessToken, hasBillingAddress } = props;

  const billingAddressPayload = hasBillingAddress ? omit(values, ['date_created', 'date_modified', '_id']) : omit(values, ['ssoId']);

  const billingCall = hasBillingAddress ?
    updateBillingAddress.bind(null, accessToken, feeProfileId, billingAddressPayload) :
    createBillingAddress.bind(null, accessToken, ssoId, billingAddressPayload);

  return dispatch(billingCall())
    .then(() => {
      window.location.href = '/account/methods';
      return null;
    })
    .catch(() => {
      throw new SubmissionError({ _error: <FormattedMessage id="hosting.on_submit_billing_address_form.error_message" defaultMessage="Submission failed. Please refresh and try again." /> });
    });
};

export default onSubmitBillingAddressForm;
